import React from "react";
import ReactECharts from 'echarts-for-react';
import _ from "lodash";
import PropTypes from "prop-types";

const DoubleAxisChart = (props) => {
    const {
        chartData,
        events,
        spaceBottom = "15%",
        spaceLeft = "5%",
        spaceRight = "5%",
        spaceTop = "13%",
        chartheight,
        xAxisData,
        XaxisLabelFormat,
        legendData,
        barwidth,
    } = props;

    const getLineOption = () => {
        const option = {
            tooltip: {
                trigger: 'axis',
show:true
            },
            legend: {
                data:legendData,
                icon: "circle",
            },
            xAxis: {
                type: 'category',
                name: "Days",
                data: xAxisData,
                nameLocation: "middle",
                nameGap: 40,
                splitLine: { show: false },
                axisLabel: XaxisLabelFormat ? XaxisLabelFormat:{}
            },
            yAxis: [
                {
                    type: 'value',
                    name: 'Count',
                    nameLocation: "middle",
                    nameGap: 40,
                    splitLine: { show: true },
                },
            ],
            grid: {
                top: spaceTop,
                left: spaceLeft,
                right: spaceRight,
                bottom: spaceBottom,
                containLabel: true,
            },
            series: chartData.map((item) => ({
                name: item.name,
                type: item.type,
                color: item.color,
                barWidth:barwidth,
                data: item.data,
                ...(item.type === 'line' && {
                    areaStyle: item.areaStyle || {},
                    z: item.z ?? 0,
                    smooth:true,
                })
            }))
        };
        return option;
    };



    const handleChartClick = (params) => {
        props.onChartClick(params);
    };

    const handleChartReady = (chart) => {

    };
    const handleLegendSelectChanged = (params) => {
    };
    const onEvents = {
        'click': handleChartClick, // chart click event
        'legendselectchanged': handleLegendSelectChanged, // legend click event
    };
    return (
        <div style={{ height: chartheight ? chartheight : null }}>
            <ReactECharts option={getLineOption()} onEvents={events ? onEvents : ""} onChartReady={handleChartReady} />
        </div>
    );
};

function areEqual(prevProps, nextProps) {
    if (_.isEqual(prevProps.showLegend, nextProps.showLegend) &&
        _.isEqual(prevProps.spaceTop, nextProps.spaceTop)) {
        return true;
    } else {
        return false;
    }
}

DoubleAxisChart.propTypes = {
    events: PropTypes.bool,
    chartheight: PropTypes.any,
    spaceTop: PropTypes.number,
    spaceLeft: PropTypes.number,
    spaceRight: PropTypes.number,
    spaceBottom: PropTypes.number,
    chartData: PropTypes.array,
    onChartClick: PropTypes.func,
};


export default React.memo(DoubleAxisChart, areEqual);


